<template>
  <label class="switch" :class="{active:value}">
    <span></span>
    <input type="checkbox" title="switch" v-model="value">
  </label>
</template>

<script>
  export default {
    componentName: "Switch",
    props: {
      input: {
        type: Boolean,
        default: true
      }
    },
    model: {
      prop: "input",
      event: "input"
    },
    watch: {
      input(newVal){
        this.value = newVal
      },
      value: function (newVal) {
        this.$emit("input",newVal)
      },
    },
    data() {
      return {
        value: this.input
      }
    }
  }
</script>

<style type="text/less" lang="less" scoped>
  @import "../../assets/style/color";
  @import "../../assets/style/config";
  @import "../../assets/style/mixin";

  .switch {
    display: inline-block;
    width: 25px;
    background-color: rgb(204, 204, 204);
    height: 12px;
    position: relative;
    border-radius: 15px;

    span {
      display: inline-block;
      height: 14px;
      width: 14px;
      left: 0;
      position: absolute;
      background-color: rgb(136, 136, 136);
      top: -1px;
      border-radius: 50%;
    }

    &.active{
      background-color: rgb(213, 229, 255);
      span{
        right: 0;
        left: auto;
        background-color: rgb(45, 125, 255);
      }
    }
    input{
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/Switch.vue